import client, { getResponseData } from './client';

// >>>>> ROLE APIS
// role data will be like:
//  {
//   "id": 2,
//   "createdAt": "2026-01-26T06:48:34.536Z",
//   "updatedAt": "2026-01-26T06:48:34.536Z",
//   "deletedAt": null,
//   "createdBy": null,
//   "updatedBy": null,
//   "role": "Guest",
//   "description": "GUEST用户权限",
//   "permissions": [],
//   "status": true,
//   "builtin": true
// }
export const getRoles = (params) => {
	return client({
		url: '/roles',
		method: 'get',
		params,
	}).then((res) => getResponseData(res));
};

// role data will be like
// {
//   "id": 1,
//   "createdAt": "2026-01-26T06:48:34.536Z",
//   "updatedAt": "2026-01-26T06:48:34.536Z",
//   "deletedAt": null,
//   "createdBy": null,
//   "updatedBy": null,
//   "role": "System_Admin",
//   "description": "系统管理员权限",
//   "permissions": [],
//   "status": true,
//   "builtin": false
// },
export const getRole = (id) => {
	return client.get(`/roles/${id}`).then((res) => getResponseData(res));
};

export const getPermissions = (data) => {
	return client.get('/resources').then((res) => getResponseData(res));
};

// data should be like:
// {
//   role:
//   description:
//   permissions: []
// }
export const createRole = (data) => {
	return client({
		url: '/roles',
		method: 'post',
		data,
	});
};

export const updateRole = (id, data) => {
	return client({
		url: `/roles/${id}`,
		method: 'patch',
		data,
	});
};

export const deleteRole = (id) => {
	return client({
		url: `/roles/${id}`,
		method: 'delete',
	});
};

// >>>>> USER APIS
// user data will be like:
// {
// 	"id": 2,
// 	"createdAt": "2026-01-28T07:09:55.067Z",
// 	"updatedAt": "2026-01-28T07:09:55.067Z",
// 	"deletedAt": null,
// 	"createdBy": null,
// 	"updatedBy": null,
// 	"name": "Cloud Liu",
// 	"oid": "e48df4f0-d3af-426f-a102-b4be48f2d28e",
// 	"issuer": "https://login.microsoftonline.com/e8701075-0d9e-4ea1-991d-5a0d110a5d29/v2.0",
// 	"email": "cloud.liu@henkel.com",
// 	"roles": [
// 			{
// 					"id": 2,
// 					"createdAt": "2026-01-26T06:48:34.536Z",
// 					"updatedAt": "2026-01-26T06:48:34.536Z",
// 					"deletedAt": null,
// 					"createdBy": null,
// 					"updatedBy": null,
// 					"role": "Guest",
// 					"description": "GUEST用户权限",
// 					"permissions": [],
// 					"status": true,
// 					"builtin": true
// 			}
// 	]
// },
export const getUsers = (params) => {
	return client({
		url: '/users',
		method: 'get',
		params,
	}).then((res) => getResponseData(res));
};

export const getUserRoles = () => {
	return client({
		url: '/users/roles',
		method: 'get',
	}).then((res) => getResponseData(res));
};

export const updateUserRoles = (data) => {
	return client({
		url: '/users/updateUserRole',
		method: 'patch',
		data,
	});
};

export const updateUserApplications = (data) => {
	return client({
		url: '/users/updateUserApplication',
		method: 'patch',
		data,
	});
};
